import { Box, Typography, Grid } from "@mui/material";
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import ElectricBoltOutlinedIcon from '@mui/icons-material/ElectricBoltOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';

const ExperienceStats = ({ user, profile }) => {
  const stats = [
    {
      label: "SERVICIOS REALIZADOS",
      value: "237",
      icon: <LocalShippingOutlinedIcon sx={{ color: '#0E2465', fontSize: 28 }} />,
    },
    {
      label: "EVALUACIONES",
      value: "90+",
      icon: <StarBorderOutlinedIcon sx={{ color: '#0E2465', fontSize: 28 }} />,
    },
    {
      label: "EXPERIENCIA",
      value: "4 años",
      icon: <ElectricBoltOutlinedIcon sx={{ color: '#0E2465', fontSize: 28 }} />,
    },
    {
      label: "IDENTIDAD",
      value: "Verificado",
      icon: <VerifiedUserOutlinedIcon sx={{ color: '#0E2465', fontSize: 28 }} />,
    }
  ];

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, color: '#0E2465', mb: 0.5 }}>
        Experiencia One Service
      </Typography>
      <Typography variant="body2" sx={{ color: '#737791', display: 'block', mb: 3 }}>
        Experiencia como proveedor
      </Typography>

      <Box className="stats-container-row">
        <Grid container spacing={3}>
          {stats.map((stat, index) => (
            <Grid key={index} size={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left', textAlign: 'left' }}>
                <Box sx={{ mb: 1.5 }}>
                  {stat.icon}
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    color: '#737791',
                    fontWeight: 600,
                    mb: 0.5,
                    fontSize: '0.7rem'
                  }}
                >
                  {stat.label}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: '#000',
                    fontSize: '1.25rem'
                  }}
                >
                  {stat.value}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ExperienceStats;
